import { RoleActiveTools } from '@/components/ai/RoleActiveTools';

/**
 * Sponsor Active Tools Page
 * Uses the universal RoleActiveTools + DynamicToolRunner system.
 * Replaces the legacy SponsorToolsPage with hardcoded tool modals.
 */
export default function SponsorAiTools() {
  return (
    <div className="mx-auto max-w-5xl px-4 py-6">
      <RoleActiveTools
        role="sponsor"
        title="Your AI Tools"
        description="Launch your active AI tools for drafting, analysis, and business intelligence."
        marketplacePath="/sponsor/ai/marketplace"
        showComingSoon={true}
      />
    </div>
  );
}
